import * as actionTypes from '../actions/actionTypes'
import {
  crudInitialState,
  itemLoad,
  itemLoaded,
  itemsLoadedAll,
  itemLoadFailed,
  itemSave,
  itemSavedCache,
  itemSaveFailed,
  itemsLoad,
  itemsLoaded,
  itemsLoadFailed,
  itemsChangeSortOrder,
  itemDelete,
  itemDeleted,
  itemDeleteFailed,
  itemsOrder,
} from './crud'

const initialState = crudInitialState

const actionHandlers = {
  [actionTypes.PROVENANCE_PERSONS_LOAD]: itemsLoad,
  [actionTypes.PROVENANCE_PERSONS_LOADED]: itemsLoaded,
  [actionTypes.PROVENANCE_PERSONS_LOADED_ALL]: itemsLoadedAll,
  [actionTypes.PROVENANCE_PERSONS_LOAD_FAILED]: itemsLoadFailed,
  [actionTypes.PROVENANCE_PERSON_LOAD]: itemLoad,
  [actionTypes.PROVENANCE_PERSON_LOADED]: itemLoaded,
  [actionTypes.PROVENANCE_PERSON_LOAD_FAILED]: itemLoadFailed,
  [actionTypes.PROVENANCE_PERSON_UPDATE]: itemSave,
  [actionTypes.PROVENANCE_PERSON_CREATE]: itemSave,
  [actionTypes.PROVENANCE_PERSON_UPDATED]: itemSavedCache,
  [actionTypes.PROVENANCE_PERSON_CREATED]: itemSavedCache,
  [actionTypes.PROVENANCE_PERSON_UPDATE_FAILED]: itemSaveFailed,
  [actionTypes.PROVENANCE_PERSON_CREATE_FAILED]: itemSaveFailed,
  [actionTypes.PROVENANCE_PERSONS_CHANGE_SORT_ORDER]: itemsChangeSortOrder,
  [actionTypes.PROVENANCE_PERSONS_ORDER]: itemsOrder,
  [actionTypes.PROVENANCE_PERSON_DELETE]: itemDelete,
  [actionTypes.PROVENANCE_PERSON_DELETED]: itemDeleted,
  [actionTypes.PROVENANCE_PERSON_DELETE_FAILED]: itemDeleteFailed,
}

export default (state = initialState, { type, payload }) => {
  const handler = actionHandlers[type]
  return handler ? handler(state, payload) : state
}
